import { produce } from "immer";
/** Returns true if an image item is a client-side image (uses a "blob:" url) */
function isClientSideImage(image) {
    return [image.originalSourceUrl, image.previewUrl, image.printUrl].some(url => url === null || url === void 0 ? void 0 : url.startsWith("blob:"));
}
/** Returns a deep copy of the provided CimDoc with any client-side images filtered out */
export function filterNonServerRenderableItems(cimDoc) {
    return produce(cimDoc, draft => {
        draft.document.panels.forEach((panel) => {
            var _a, _b;
            // Remove any images from the document that are client-side images resulting from instant uploads
            panel.images = (_b = (_a = panel.images) === null || _a === void 0 ? void 0 : _a.filter((image) => !isClientSideImage(image))) !== null && _b !== void 0 ? _b : [];
        });
    });
}
//# sourceMappingURL=filterNonServerRenderableItems.js.map